export default __webpack_public_path__ + "static/media/8.22ccb918.png";